import { CSSProperties, FC } from 'react'
import { useTranslation } from 'next-i18next'

import styles from './styles.module.scss'

type Props = {
  style?: CSSProperties
}

export const GgMapsServiceIntro: FC<Props> = ({ style }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.banner} style={style}>
      <img className={styles.icon} src="/lightbulb_icon.svg" alt="" aria-hidden />
      <p className={styles.text}>{t('SPACE_DETAIL.GG_MAPS_SERVICE_INTRO')}</p>
    </div>
  )
}
